import { Modal } from "react-bootstrap"
import { getAllEquipmentUnitCategoriesByProfileId } from "../../../../api"
import { useQuery } from "react-query"
import { useEffect, useState } from "react"
import { checkForAPISuccess,checkIfNoRecords, showErrorToast } from "../../../../Common/commonFunctions"
import PerfectScrollbar from 'react-perfect-scrollbar';
import ClipLoader from "react-spinners/ClipLoader"
import { useDispatch } from "react-redux"
import { SET_JSON_FROM_SELECTED_GLOBAL_CATEGROY } from "../../../../store/actions"
import _ from "lodash"

const GlobalCategoriesPopup = props => {

    const [utils, setUtils] = useState({ categories: [] });

    const dispatch = useDispatch();
    const useQueryConfiguration = {
        enabled: false, retry: false, retryOnMount: false,
        refetchOnMount: false, refetchOnWindowFocus: false
    }

    const fetchCategories = async () => {
        const response = await getAllEquipmentUnitCategoriesByProfileId('');
        return response?.data;
    }

    const fetchCategoriesQuery = useQuery('get-global-categories', fetchCategories, { ...useQueryConfiguration });

    const handleCategorySelect = (json) => {
        dispatch({ type: SET_JSON_FROM_SELECTED_GLOBAL_CATEGROY, payload: json });
    }

    useEffect(() => {
        fetchCategoriesQuery.refetch();
    }, []);

    useEffect(() => {
        if(fetchCategoriesQuery.isFetched) {
            if(
                checkForAPISuccess(fetchCategoriesQuery?.data?.statusCode) ||
                checkIfNoRecords(fetchCategoriesQuery?.data?.statusCode)
            ) {
                setUtils({ ...utils, categories: fetchCategoriesQuery?.data?.data?.categories });
            }
            else {
                showErrorToast('Failed to fetch global categories', 4000);
            }
            fetchCategoriesQuery.remove();
        }
    }, [fetchCategoriesQuery.isFetched]);

    return (
        <Modal backdrop="static" show onHide={() => props.closePopup()}>
            <Modal.Header closeButton>
                <h5>
                    <b>Global categories</b>
                </h5>
            </Modal.Header>
            <Modal.Body className="w-95">
                {
                    fetchCategoriesQuery.isFetching ?
                        <center className="my-5">
                            <ClipLoader color="#075978" />
                        </center>
                            :
                        <>
                            {
                                !_.isEmpty(utils.categories) ?
                                    <PerfectScrollbar className="global-category-scrollbox">
                                        {
                                            utils.categories?.map(category =>
                                                <div
                                                    className="global-category-item"
                                                    onClick={() => handleCategorySelect(category.categoryJson)}
                                                >
                                                    <div>
                                                        {category.name}
                                                    </div>
                                                    <div className="text-color-grey">
                                                        {category.components}
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </PerfectScrollbar>
                                        :
                                    <center className="my-5">
                                        <b>No global categories found.</b>
                                    </center>
                            }
                        </>
                }
            </Modal.Body>
        </Modal>
    );
}

export default GlobalCategoriesPopup;